const testimonialSliders = document.querySelectorAll('[data-slider="testimonials-slider"');
if (testimonialSliders.length) {
    testimonialSliders.forEach(slider => {
        let parentEle = jQuery(slider.closest('.testimonials'));
        jQuery(slider).slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            arrows: true,
            prevArrow: parentEle.find(jQuery('.testimonial-slider.prev')),
            nextArrow: parentEle.find(jQuery('.testimonial-slider.next')),
            rows: 0,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 501,
                settings: {
                  slidesToShow: 1,
                }
              }
            ]
        });
    });
}
